<template>
    <layout>
        <!-- ========== 衍泰AI 模块 ========== -->
        <div class="yantai-ai-section">
            <div class="ai-bg"></div>
            <div class="container">
                <div class="ai-content">
                    <h1 class="ai-title">
                        <span class="highlight">{{ $t('yantai.heroHl') }}</span>{{ $t('yantai.heroTitle') }}
                    </h1>
                    <p class="ai-desc">
                        {{ $t('yantai.heroDesc') }}
                    </p>
                    <div class="ai-buttons">
                        <button class="btn-ai primary">
                            {{ $t('yantai.heroBtn1') }} <span class="arrow">↗</span>
                        </button>
                        <button class="btn-ai outline" @click="openAiGenNext">
                            {{ $t('yantai.heroBtn2') }} <span class="arrow">↗</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- ========== 新增：四个固定轮播盒子模块 ========== -->
        <div class="yantai-ai-carousel-section" style="padding-bottom: 80px;">
            <div class="bg-transition-glow"></div>
            <div class="container">

                <!-- 标题区 -->
                <div class="carousel-header">
                    <h2 class="carousel-header-title">{{ $t('yantai.headerTitle') }}</h2>
                    <p class="carousel-header-desc">{{ $t('yantai.headerDesc') }}</p>
                </div>

                <div class="ai-carousel touch-glow">
                    <transition name="fade" mode="out-in">
                        <div :key="currentAICardIndex" class="ai-card">

                            <!-- 盒子1：多设备统一管控 -->
                            <div v-if="currentAICardIndex === 0" class="carousel-inner">
                                <div class="carousel-text">
                                    <div class="ai-icon-badge">
                                        <img src="@/assets/images/icons/yantaiai-icon1.png" alt="多设备">
                                    </div>
                                    <h3 class="carousel-title">{{ $t('yantai.box1Title') }}</h3>
                                    <p class="carousel-desc">{{ $t('yantai.box1Desc') }}</p>
                                    <ul class="carousel-list">
                                        <li><span class="dot"></span> {{ $t('yantai.box1Item1') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box1Item2') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box1Item3') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box1Item4') }}</li>
                                    </ul>
                                </div>

                                <!-- 设备管理面板盒子（绝对定位突出父盒子） -->
                                <div class="device-panel">
                                    <div class="dp-header">
                                        <div class="dp-title">
                                            <span><img src="@/assets/images/icons/30.png" alt=""></span>
                                            <div class="dp-title-text">
                                                <div class="dp-name">多设备统一管控</div>
                                                <div class="dp-subtitle">开启后批量管理海量设备，提高效率</div>
                                            </div>
                                        </div>
                                        <div class="dp-add-btn"><span class="plus">+</span> 添加设备</div>
                                    </div>

                                    <div class="dp-body">

                                        <div class="dp-stats">
                                            <div class="stat-item">
                                                <span class="stat-icon">
                                                    <img src="@/assets/images/icons/组 5897.png" alt="">
                                                </span>
                                                <div class="stat-text">
                                                    <div class="stat-num">24</div>
                                                    <div class="stat-label">设备总数</div>
                                                </div>
                                            </div>
                                            <div class="stat-item">
                                                <span class="stat-icon">
                                                    <img src="@/assets/images/icons/组 5897 (1).png" alt="">
                                                </span>
                                                <div class="stat-text">
                                                    <div class="stat-num">18</div>
                                                    <div class="stat-label">在线设备</div>
                                                </div>
                                            </div>
                                            <div class="stat-item">
                                                <span class="stat-icon">
                                                    <img src="@/assets/images/icons/组 5897 (2).png" alt="">
                                                </span>
                                                <div class="stat-text">
                                                    <div class="stat-num">4</div>
                                                    <div class="stat-label">离线设备</div>
                                                </div>
                                            </div>
                                            <div class="stat-item">
                                                <span class="stat-icon">
                                                    <img src="@/assets/images/icons/组 5897 (3).png" alt="">
                                                </span>
                                                <div class="stat-text">
                                                    <div class="stat-num">2</div>
                                                    <div class="stat-label">待机设备</div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="dp-filter">
                                            <div class="dp-search">
                                                <svg class="search-icon" viewBox="0 0 24 24" width="14" height="14"
                                                    fill="none" stroke="currentColor" stroke-width="2">
                                                    <circle cx="11" cy="11" r="7" />
                                                    <line x1="21" y1="21" x2="16.5" y2="16.5" />
                                                </svg>
                                                请输入设备名称/ID
                                            </div>
                                            <div class="dp-tags">
                                                <span class="tag active">全部</span>
                                                <span class="tag">在线</span>
                                                <span class="tag">离线</span>
                                                <span class="tag">空闲</span>
                                            </div>
                                            <div class="dp-batch">
                                                <svg viewBox="0 0 24 24" width="14" height="14" fill="none"
                                                    stroke="currentColor" stroke-width="2">
                                                    <rect x="3" y="3" width="7" height="7" rx="1" />
                                                    <rect x="14" y="3" width="7" height="7" rx="1" />
                                                    <rect x="3" y="14" width="7" height="7" rx="1" />
                                                    <rect x="14" y="14" width="7" height="7" rx="1" />
                                                </svg>
                                                批量操作
                                            </div>
                                        </div>

                                        <div class="dp-list">
                                            <div class="device-card">
                                                <div class="dev-icon">
                                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
                                                        stroke="#fff" stroke-width="1.8">
                                                        <rect x="5" y="3" width="14" height="18" rx="2" />
                                                        <line x1="9" y1="18" x2="15" y2="18" />
                                                    </svg>
                                                </div>
                                                <div class="dev-info">
                                                    <div class="dev-name">iPad Pro 12.9" <span
                                                            class="badge blue">主控</span></div>
                                                    <div class="dev-id">ID: D-1024 最后活跃: 12:38  <span class="dev-status green-dot">在线</span></div>   
                                                </div>
                                            
                                                <div class="dev-setting">
                                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                                                        stroke="currentColor" stroke-width="2">
                                                        <line x1="4" y1="6" x2="20" y2="6" />
                                                        <circle cx="9" cy="6" r="2" />
                                                        <line x1="4" y1="12" x2="20" y2="12" />
                                                        <circle cx="15" cy="12" r="2" />
                                                        <line x1="4" y1="18" x2="20" y2="18" />
                                                        <circle cx="7" cy="18" r="2" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="device-card">
                                                <div class="dev-icon">
                                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
                                                        stroke="#fff" stroke-width="1.8">
                                                        <rect x="5" y="3" width="14" height="18" rx="2" />
                                                        <line x1="9" y1="18" x2="15" y2="18" />
                                                    </svg>
                                                </div>
                                                <div class="dev-info">
                                                    <div class="dev-name">Huawei MatePad <span
                                                            class="badge green">活跃</span></div>
                                                    <div class="dev-id">ID: D-1024 最后活跃: 12:38  <span class="dev-status green-dot">在线</span></div>
                                                </div>
                                               
                                                <div class="dev-setting">
                                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                                                        stroke="currentColor" stroke-width="2">
                                                        <line x1="4" y1="6" x2="20" y2="6" />
                                                        <circle cx="9" cy="6" r="2" />
                                                        <line x1="4" y1="12" x2="20" y2="12" />
                                                        <circle cx="15" cy="12" r="2" />
                                                        <line x1="4" y1="18" x2="20" y2="18" />
                                                        <circle cx="7" cy="18" r="2" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="device-card">
                                                <div class="dev-icon">
                                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
                                                        stroke="#fff" stroke-width="1.8">
                                                        <rect x="3" y="4" width="18" height="13" rx="2" />
                                                        <line x1="9" y1="21" x2="15" y2="21" />
                                                        <line x1="12" y1="17" x2="12" y2="21" />
                                                    </svg>
                                                </div>
                                                <div class="dev-info">
                                                    <div class="dev-name">MacBook Pro 16" <span
                                                            class="badge yellow">待机</span></div>
                                                    <div class="dev-id">ID: D-1024 最后活跃: 12:38   <span class="dev-status yellow-dot">空闲</span></div>
                                                </div>
                                              
                                                <div class="dev-setting">
                                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                                                        stroke="currentColor" stroke-width="2">
                                                        <line x1="4" y1="6" x2="20" y2="6" />
                                                        <circle cx="9" cy="6" r="2" />
                                                        <line x1="4" y1="12" x2="20" y2="12" />
                                                        <circle cx="15" cy="12" r="2" />
                                                        <line x1="4" y1="18" x2="20" y2="18" />
                                                        <circle cx="7" cy="18" r="2" />
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="device-card">
                                                <div class="dev-icon">
                                                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
                                                        stroke="#fff" stroke-width="1.8">
                                                        <rect x="3" y="4" width="18" height="13" rx="2" />
                                                        <line x1="9" y1="21" x2="15" y2="21" />
                                                        <line x1="12" y1="17" x2="12" y2="21" />
                                                    </svg>
                                                </div>
                                                <div class="dev-info">
                                                    <div class="dev-name">Dell XPS 15 <span class="badge red">离线</span>
                                                    </div>
                                                    <div class="dev-id">ID: D-1024 最后活跃: 12:38   <div class="dev-status red-dot"> 离线</div></div>
                                                </div>
                                              
                                                <div class="dev-setting">
                                                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none"
                                                        stroke="currentColor" stroke-width="2">
                                                        <line x1="4" y1="6" x2="20" y2="6" />
                                                        <circle cx="9" cy="6" r="2" />
                                                        <line x1="4" y1="12" x2="20" y2="12" />
                                                        <circle cx="15" cy="12" r="2" />
                                                        <line x1="4" y1="18" x2="20" y2="18" />
                                                        <circle cx="7" cy="18" r="2" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="dp-pagination">
                                            <span class="page-arrow">&lt;</span>
                                            <span class="page-num active">1</span>
                                            <span class="page-num">2</span>
                                            <span class="page-num">3</span>
                                            <span class="page-num">4</span>
                                            <span class="page-num">5</span>
                                            <span class="page-arrow">&gt;</span>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <!-- 盒子2：AI智能互动（已按截图修改内容） -->
                            <div v-else-if="currentAICardIndex === 1" class="carousel-inner">
                                <div class="carousel-text">
                                    <div class="ai-icon-badge"><img src="@/assets/images/icons/yantaiai-icon2.png"
                                            alt="AI互动"></div>
                                    <h3 class="carousel-title">{{ $t('yantai.box2Title') }}</h3>
                                    <p class="carousel-desc">{{ $t('yantai.box2Desc') }}</p>
                                    <ul class="carousel-list">
                                        <li><span class="dot"></span> {{ $t('yantai.box2Item1') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box2Item2') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box2Item3') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box2Item4') }}</li>
                                    </ul>
                                </div>

                                <!-- AI智能互动面板（绝对定位突出父盒子） -->
                                <div class="ai-interaction-panel">
                                    <!-- 面板头部 -->
                                    <div class="aip-header">
                                        <div class="aip-title">
                                            <span>
                                                <img src="@/assets/images/icons/32.png" alt="">
                                            </span>
                                            <div class="aip-title-text">
                                                <div class="aip-name">AI智能互动</div>
                                                <div class="aip-subtitle">自动回复、自动捕捉潜在用户</div>
                                            </div>
                                        </div>
                                        <div class="aip-auto-btn">
                                            <svg viewBox="0 0 24 24" width="12" height="12" fill="#fff">
                                                <path d="M13 2L4.5 13.5H11L10 22l8.5-11.5H12L13 2z" />
                                            </svg>
                                            自动
                                        </div>
                                    </div>

                                    <!-- 面板内容 -->
                                    <div class="aip-body">
                                        <!-- 功能卡片第一行（4个） -->
                                        <div class="aip-cards row-4">
                                            <div class="aip-card">
                                                <span class="card-icon">
                                                    <img src="@/assets/images/icons/组 5530.png" alt="">
                                                </span>
                                                <div class="card-name">AI评论自动回复</div>
                                                <div class="card-desc">感谢您的支持！更多详情请关注主页 👇</div>
                                            </div>
                                            <div class="aip-card">
                                                <span class="card-icon">
                                                    <img src="@/assets/images/icons/组 5537.png" alt="">
                                                </span>
                                                <div class="card-name">AI私信自动回复</div>
                                                <div class="card-desc">“您好，请问有什么可以帮到您的？”</div>
                                            </div>
                                            <div class="aip-card">
                                                <span class="card-icon">
                                                    <img src="@/assets/images/icons/组 5544.png" alt="">
                                                </span>
                                                <div class="card-name">AI自动改写</div>
                                                <div class="card-desc">已针对 TikTok/Ins 生成差异化版本文案</div>
                                            </div>
                                            <div class="aip-card">
                                                <span class="card-icon">
                                                    <img src="@/assets/images/icons/组 5553.png" alt="">
                                                </span>
                                                <div class="card-name">AI监控回复</div>
                                                <div class="card-desc">已自动回复 5 条正面提及</div>
                                            </div>
                                        </div>

                                        <!-- 功能卡片第二行（3个） -->
                                        <div class="aip-cards row-3">
                                            <div class="aip-card">
                                                <span class="card-icon">
                                                    <img src="@/assets/images/icons/组 5614.png" alt="">
                                                </span>
                                                <div class="card-name">关键词识别</div>
                                                <div class="card-desc">实时抓取行业热点，完成情绪分析</div>
                                            </div>
                                            <div class="aip-card">
                                                <span class="card-icon">
                                                    <img src="@/assets/images/icons/组 5632.png" alt="">
                                                </span>
                                                <div class="card-name">潜在用户捕捉</div>
                                                <div class="card-desc">自动识别意向用户，提升客户转化效率</div>
                                            </div>
                                            <div class="aip-card">
                                                <span class="card-icon">
                                                    <img src="@/assets/images/icons/组 5615.png" alt="">
                                                </span>
                                                <div class="card-name">智能运营助手</div>
                                                <div class="card-desc">助力品牌社交媒体运营更专业高效</div>
                                            </div>
                                        </div>

                                        <!-- 数据统计 -->
                                        <div class="aip-stats">
                                            <div class="aip-stat">
                                                <div class="stat-label">今日互动总量</div>
                                                <div class="stat-value">1,284<span class="unit">次</span></div>
                                                <div class="stat-trend up">较昨日 +12%</div>
                                            </div>
                                            <div class="aip-stat">
                                                <div class="stat-label">节省运营成本</div>
                                                <div class="stat-value">3.2<span class="unit">小时</span></div>
                                                <div class="stat-trend">自动处理87%常规咨询</div>
                                            </div>
                                            <div class="aip-stat">
                                                <div class="stat-label">自动回复数量</div>
                                                <div class="stat-value">342<span class="unit">条</span></div>
                                                <div class="stat-trend">私信12·评论35</div>
                                            </div>
                                            <div class="aip-stat">
                                                <div class="stat-label">潜在用户捕捉</div>
                                                <div class="stat-value">12<span class="unit">人</span></div>
                                                <div class="stat-trend">今日新增意向用户</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 盒子3：AI一键产出素材 -->
                            <div v-else-if="currentAICardIndex === 2" class="carousel-inner">
                                <div class="carousel-text">
                                    <div class="ai-icon-badge"><img src="@/assets/images/icons/yantaiai-icon3.png"
                                            alt="AI素材"></div>
                                    <h3 class="carousel-title">{{ $t('yantai.box3Title') }}</h3>
                                    <p class="carousel-desc">{{ $t('yantai.box3Desc') }}</p>
                                    <ul class="carousel-list">
                                        <li><span class="dot"></span> {{ $t('yantai.box3Item1') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box3Item2') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box3Item3') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box3Item4') }}</li>
                                    </ul>
                                </div>

                                <!-- AI素材创作面板（绝对定位突出父盒子） -->
                                <div class="ai-material-panel">
                                    <!-- 面板头部 -->
                                    <div class="amp-header">
                                        <div class="amp-title">
                                            <span>
                                                <img src="@/assets/images/icons/31.png" alt="">
                                            </span>
                                            <div class="amp-title-text">
                                                <div class="amp-name">AI 素材创作</div>
                                                <div class="amp-subtitle">视频、图片、文章</div>
                                            </div>
                                        </div>
                                        <div class="amp-auto-btn">
                                            <svg viewBox="0 0 24 24" width="13" height="13" fill="#fff">
                                                <path
                                                    d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z" />
                                            </svg>
                                            自动
                                        </div>
                                    </div>

                                    <!-- 面板内容 -->
                                    <div class="amp-body">
                                        <!-- 左列 -->
                                        <div class="amp-left">
                                            <!-- 风格模型（可交互） -->
                                            <div class="amp-style-card">
                                                <div class="amp-style-head">
                                                    <span class="amp-style-title">风格模型</span>
                                                    <span class="amp-more">更多</span>
                                                </div>
                                                <div class="amp-style-grid">
                                                    <span v-for="(style, i) in styleModels" :key="style"
                                                        class="style-btn" :class="{ active: activeStyleIndex === i }"
                                                        @click="activeStyleIndex = i">{{ style }}</span>
                                                </div>
                                            </div>

                                            <!-- 输入卡片（图片占位，可自行替换为 img） -->
                                            <div class="amp-input-card">
                                                <p class="amp-input-placeholder">上传参考图、输入文字，<br>描述你想生成的图片</p>
                                                <span class="amp-input-icon">
                                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none"
                                                        stroke="currentColor" stroke-width="1.8">
                                                        <rect x="3" y="3" width="18" height="18" rx="3" />
                                                        <circle cx="8.5" cy="8.5" r="1.5" />
                                                        <path d="m21 15-5-5L5 21" />
                                                        <path d="M19 3v4M17 5h4" stroke-linecap="round" />
                                                    </svg>
                                                </span>
                                            </div>

                                            <!-- 生成按钮 -->
                                            <button class="amp-generate-btn">生成</button>
                                        </div>

                                        <!-- 右侧画布（图片占位，可自行替换为 img） -->
                                        <div class="amp-canvas-card">
                                            <div class="amp-canvas-toolbar">
                                                <span class="amp-save-btn">
                                                    <svg viewBox="0 0 24 24" width="13" height="13" fill="none"
                                                        stroke="currentColor" stroke-width="2">
                                                        <path
                                                            d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                                                        <path d="M17 21v-8H7v8M7 3v5h8" />
                                                    </svg>
                                                    保存设计
                                                </span>
                                                <div class="amp-scale-switch">
                                                    <span class="scale active">1x</span>
                                                    <span class="scale">2x</span>
                                                </div>
                                            </div>
                                            <div class="amp-canvas-area"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- 盒子4：7×24小时在线（AI客服，图片撑满右侧模块盒子） -->
                            <div v-else-if="currentAICardIndex === 3" class="carousel-inner">
                                <div class="carousel-text">
                                    <div class="ai-icon-badge"><img src="@/assets/images/icons/yantaiai-icon4.png"
                                            alt="24小时"></div>
                                    <h3 class="carousel-title">{{ $t('yantai.box4Title') }}</h3>
                                    <p class="carousel-desc">{{ $t('yantai.box4Desc') }}</p>
                                    <ul class="carousel-list">
                                        <li><span class="dot"></span> {{ $t('yantai.box4Item1') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box4Item2') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box4Item3') }}</li>
                                        <li><span class="dot"></span> {{ $t('yantai.box4Item4') }}</li>
                                    </ul>
                                </div>

                                <!-- AI客服图片（桌面/移动使用不同裁切图，撑满右侧模块盒子） -->
                                <div class="ai-service-image">
                                    <img class="service-img-desktop" src="@/assets/images/bg/80 overflow-hidden.png"
                                        alt="AI客服" />
                                    <img class="service-img-mobile" src="@/assets/images/bg/80 overflow-hidden1.png"
                                        alt="AI客服" />
                                </div>
                            </div>

                            <!-- 底部左右切换箭头 -->
                            <div class="ai-card-nav">
                                <span class="arrow-btn" @click="prevCard"> &lt; </span>
                                <span class="arrow-btn" @click="nextCard"> &gt; </span>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>

        <!-- ========== AiGenNext 孵化项目模块 ========== -->
        <div class="aigennext-section">
            <div class="aigennext-bg"></div>
            <div class="container">
                <div class="aigennext-content">
                    <h3 class="aigennext-logo">AiGenNext</h3>
                    <h2 class="aigennext-title">
                        <span class="w3">{{ $t('yantai.agHead1') }}</span>{{ $t('yantai.agHead2') }}<span class="evo">{{
                            $t('yantai.agHead3') }}</span>
                    </h2>
                    <p class="aigennext-desc">
                        {{ $t('yantai.agDesc') }}
                    </p>
                    <div class="aigennext-btn-wrap">
                        <button class="aigennext-btn" @click="openAiGenNext">{{ $t('yantai.agBtn') }}</button>
                    </div>
                </div>
            </div>
        </div>

        <share-modal />
        <report-modal />
    </layout>
</template>

<script>
import Layout from '@/components/layouts/Layout'
import ShareModal from '@/components/modal/ShareModal'
import ReportModal from '@/components/modal/ReportModal'
export default {
    name: 'YantaiAI',
    components: { Layout, ShareModal, ReportModal },
    data() {
        return {
            currentAICardIndex: 0,
            // 风格模型按钮（右侧面板不做多语言，固定中文）
            styleModels: ['写实', '插画', '3D', '电影感', '水彩', '赛博'],
            activeStyleIndex: 0
        }
    },
    methods: {
        nextCard() {
            this.currentAICardIndex = (this.currentAICardIndex + 1) % 4;
        },
        prevCard() {
            this.currentAICardIndex = (this.currentAICardIndex - 1 + 4) % 4;
        },
        // 跳转 AiGenNext 官网（新窗口打开）
        openAiGenNext() {
            window.open('https://www.aigennext.ai/');
        }
    }
}
</script>

<style scoped lang="scss">
.yantai-ai-section {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    overflow: hidden;
    background: #0A0C1E;
}

.ai-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-image: url('~@/assets/images/bg/Image (1).png');
    background-size: cover;
    background-position: center;
}

.ai-content {
    position: relative;
    z-index: 2;
    text-align: center;
    width: 100%;
    padding: 120px 20px;
}

.ai-title {
    font-size: 64px;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 24px;

    .highlight {
        color: #FFD200;
    }
}

.ai-desc {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.8;
    max-width: 760px;
    margin: 0 auto 48px;
}

.ai-buttons {
    display: flex;
    justify-content: center;
    gap: 24px;
}

.btn-ai {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 52px;
    padding: 0 40px;
    border-radius: 26px;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 250px;
    line-height: 18px;

    .arrow {
        font-size: 20px;
        line-height: 1;
    }

    &.primary {
        background: #FFD200;
        border: none;
        color: #181A20;

        &:hover {
            box-shadow: 0 0 25px rgba(255, 210, 0, 0.5);
            transform: translateY(-2px);
        }
    }

    &.outline {
        background: transparent;
        border: 1px solid rgba(255, 255, 255, 0.4);
        color: #FFFFFF;

        &:hover {
            border-color: rgba(255, 255, 255, 0.8);
            box-shadow: 0 0 25px rgba(255, 255, 255, 0.25);
            transform: translateY(-2px);
        }
    }
}

.carousel-header {
    text-align: center;
    margin-bottom: 100px;
    padding-top: 60px;

    .carousel-header-title {
        font-size: 42px;
        font-weight: 700;
        color: #FFFFFF;
        margin-bottom: 16px;
        letter-spacing: 1px;
    }

    .carousel-header-desc {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.75);
        max-width: 760px;
        margin: 0 auto;
        line-height: 1.6;
    }
}

.touch-glow {
    transition: all 0.3s ease;
}

.yantai-ai-carousel-section {
    background: transparent;
    color: #fff;
    position: relative;
    z-index: 2;
}

.bg-transition-glow {
    position: absolute;
    top: -50%;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: linear-gradient(258deg, #9900ffcc 17%, #0066ffcc 83%);
    filter: blur(306px);
    z-index: -1;
    pointer-events: none;
}

.ai-carousel {
    position: relative;
    /* 原最大宽 1000px，随面板放大整体 1.2 倍（小屏自动回缩到容器宽度） */
    max-width: min(1200px, 100%);
    margin: 0 auto;
    padding: 36px;
    border-radius: 24px;
    background: rgba(26, 31, 46, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    box-shadow: 0px 4px 30px 0px rgba(255, 210, 0, 0.2), 0px 4px 40px 0px rgba(156, 81, 244, 0.3);
    overflow: visible;
}

.ai-card {
    position: relative;
    z-index: 1;
    border-radius: 16px;
}

/* 左右布局结构 */
.carousel-inner {
    display: flex;
    align-items: center;
    gap: 48px;
    min-height: 600px;
    position: relative;
    overflow: visible;
    padding-right: 72px;
}

.carousel-text {
    flex: 1;
    padding-left: 48px;
    /* 右侧面板为绝对定位（宽 600px，左缘约在 x=460），
       限制文本宽度，避免英文等长文案延伸到面板下方被遮挡 */
    max-width: 492px;
}

.ai-icon-badge {
    margin-bottom: 20px;
}

.carousel-title {
    font-size: 43px;
    font-weight: 700;
    margin-bottom: 14px;
    color: #fff;
}

.carousel-desc {
    font-size: 19px;
    color: rgba(255, 255, 255, 0.75);
    margin-bottom: 36px;
}

.carousel-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.carousel-list li {
    display: flex;
    align-items: flex-start;
    margin-bottom: 14px;
    font-size: 18px;
    color: #FFFFFF;
}

.carousel-list .dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #FFD200;
    margin-right: 12px;
    margin-top: 6px;
    flex-shrink: 0;
}

/* ================== 多设备面板样式 ================== */
.device-panel {
    position: absolute;
    right: -120px;
    top: 50%;
    transform: translateY(-50%);
    /* 625×395.83 + zoom 1.2 → 实际渲染 750×475，内容同步放大 */
    width: 625px;
    height: 395.83px;
    zoom: 1.2;
    z-index: 2;

    background: rgba(18, 22, 32, 0.6);
    border-radius: 16px;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    color: white;
    font-family: inherit;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .dp-header {
        background: rgba(0, 0, 0, 0.8);
        padding: 14px 18px;
        flex-shrink: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .dp-title {
            display: flex;
            align-items: center;
            gap: 10px;

            .dp-logo-icon {
                width: 30px;
                height: 30px;
                flex-shrink: 0;
                background: linear-gradient(135deg, #7C5CFC, #9F7AFF);
                border-radius: 50%;
                display: inline-block;
                overflow: hidden;

                /* 图标连背景整体使用设计切图 */
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                    border-radius: 50%;
                }
            }

            .dp-title-text {
                .dp-name {
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 1.3;
                }

                .dp-subtitle {
                    font-size: 11px;
                    color: rgba(255, 255, 255, 0.5);
                    margin-top: 2px;
                }
            }
        }

        .dp-add-btn {
            background: linear-gradient(90deg, #7C5CFC, #9F7AFF);
            border-radius: 8px;
            padding: 8px 16px;
            font-size: 13px;
            cursor: pointer;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 4px;

            .plus {
                font-size: 15px;
                line-height: 1;
            }
        }
    }

    .dp-body {
        flex: 1;
        min-height: 0;
        padding: 14px 16px;
        display: flex;
        flex-direction: column;
    }

    .dp-stats {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 12px;
        margin-bottom: 14px;

        .stat-item {
            background: rgba(255, 255, 255, 0.04);
            border: 1px solid transparent;
            border-radius: 10px;
            padding: 12px;
            display: flex;
            align-items: center;
            gap: 10px;
            transition: background 0.3s ease, border-color 0.3s ease;

            &:hover {
                background: rgba(255, 255, 255, 0.1);
                border-color: rgba(255, 255, 255, 0.15);
            }

            .stat-icon {
                width: 34px;
                height: 34px;
                flex-shrink: 0;
                border-radius: 9px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;

                /* 图标连背景整体使用设计切图（设备总数/在线/离线/待机 各一张） */
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }
            }

            .stat-text {
                .stat-num {
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 1.2;
                }

                .stat-label {
                    font-size: 11px;
                    color: rgba(255, 255, 255, 0.6);
                    margin-top: 2px;
                    white-space: nowrap;
                }
            }
        }
    }

    .dp-filter {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 14px;

        .dp-search {
            flex: 1;
            background: rgba(255, 255, 255, 0.05);
            border-radius: 8px;
            padding: 8px 12px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.4);
            display: flex;
            align-items: center;
            gap: 6px;

            .search-icon {
                color: rgba(255, 255, 255, 0.4);
                flex-shrink: 0;
            }
        }

        .dp-tags {
            display: flex;
            gap: 6px;

            .tag {
                padding: 6px 14px;
                border-radius: 8px;
                font-size: 12px;
                background: rgba(255, 255, 255, 0.05);
                color: rgba(255, 255, 255, 0.7);
                cursor: pointer;
                white-space: nowrap;

                &.active {
                    background: rgba(91, 108, 255, 0.18);
                    border: 1px solid #5B6CFF;
                    color: #8C9AFF;
                }
            }
        }

        .dp-batch {
            background: rgba(255, 255, 255, 0.05);
            border-radius: 8px;
            padding: 8px 14px;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.7);
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            white-space: nowrap;
        }
    }

    .dp-list {
        flex: 1;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        margin-bottom: 12px;

        .device-card {
            background: rgba(255, 255, 255, 0.04);
            border-radius: 10px;
            padding: 12px;
            display: flex;
            align-items: center;
            border: 1px solid rgba(255, 255, 255, 0.05);

            .dev-icon {
                width: 38px;
                height: 38px;
                flex-shrink: 0;
                background: rgba(255, 255, 255, 0.08);
                border: 1px solid rgba(255, 255, 255, 0.12);
                border-radius: 9px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 10px;
            }

            .dev-info {
                flex: 1;
                min-width: 0;

                .dev-name {
                    font-size: 10px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    white-space: nowrap;
                }

                .badge {
                    padding: 2px 6px;
                    border-radius: 4px;
                    font-size: 8px;
                    font-weight: 500;

                    &.blue {
                        border-radius: 20px;
                        background: rgba(91, 124, 250, 0.12);
                        box-sizing: border-box;
                        border: 1px solid rgba(91, 124, 250, 0.08);
                        color: #7B96FF;
                    }

                    &.green {
                        border-radius: 20px;
                        background: rgba(52, 211, 153, 0.1);
                        box-sizing: border-box;
                        border: 1px solid rgba(52, 211, 153, 0.08);
                        color: #34D399;
                    }

                    &.yellow {
                        border-radius: 20px;
                        background: rgba(251, 191, 36, 0.1);
                        box-sizing: border-box;
                        border: 1px solid rgba(251, 191, 36, 0.08);
                        color: #FBBF24;
                    }

                    &.red {
                        border-radius: 20px;
                        background: rgba(251, 113, 133, 0.1);
                        box-sizing: border-box;
                        border: 1px solid rgba(251, 113, 133, 0.08);
                        color: #FB7185;
                    }
                }

                .dev-id {
                    font-size: 8px;
                    color: rgba(255, 255, 255, 0.5);
                    margin-top: 4px;
                    white-space: nowrap;
                    display: flex;
                    align-items: center;
                }
            }

            .dev-status {
                font-size: 8px;
                display: flex;
                align-items: center;
                margin-left: 8px;
                gap: 5px;
                flex-shrink: 0;


                &.green-dot {
                    color: #3DBE8B;

                    &::before {
                        content: '';
                        width: 6px;
                        height: 6px;
                        background: #3DBE8B;
                        border-radius: 50%;
                    }
                }

                &.yellow-dot {
                    color: #FFD200;

                    &::before {
                        content: '';
                        width: 6px;
                        height: 6px;
                        background: #FFD200;
                        border-radius: 50%;
                    }
                }

                &.red-dot {
                    color: #FF6B6B;

                   &::before {
                        content: '';
                        width: 6px;
                        height: 6px;
                        background: #FF6B6B;
                        border-radius: 50%;
                    }
                }
            }

            .dev-setting {
                color: rgba(255, 255, 255, 0.45);
                flex-shrink: 0;
                margin-left: 8px;
                cursor: pointer;
                transition: color 0.3s ease;

                &:hover {
                    color: #fff;
                }
            }
        }
    }

    .dp-pagination {
        display: flex;
        justify-content: center;
        gap: 10px;
        align-items: center;

        .page-arrow {
            font-size: 14px;
            color: rgba(255, 255, 255, 0.7);
            cursor: pointer;
        }

        .page-num {
            min-width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.5);
            cursor: pointer;

            &.active {
                color: #fff;
                background: none;
            }
        }
    }
}

/* ================== AI智能互动面板 ================== */
.ai-interaction-panel {
    position: absolute;
    right: -120px;
    top: 50%;
    transform: translateY(-50%);
    /* 625×395.83 + zoom 1.2 → 实际渲染 750×475，内容同步放大 */
    width: 625px;
    height: 395.83px;
    zoom: 1.2;
    z-index: 2;

    display: flex;
    flex-direction: column;

    border-radius: 16px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    color: #fff;
    font-family: inherit;

    .aip-header {
        background: rgba(0, 0, 0, 0.8);
        padding: 14px 18px;
        flex-shrink: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .aip-title {
            display: flex;
            align-items: center;
            gap: 10px;

            .aip-logo-icon {
                width: 32px;
                height: 32px;
                flex-shrink: 0;
                background: linear-gradient(135deg, #3B82F6, #2563EB);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;

                /* 图标连背景整体使用设计切图 */
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }
            }

            .aip-title-text {
                .aip-name {
                    font-size: 15px;
                    font-weight: 600;
                    line-height: 1.3;
                }

                .aip-subtitle {
                    font-size: 11px;
                    color: rgba(255, 255, 255, 0.5);
                    margin-top: 2px;
                }
            }
        }

        .aip-auto-btn {
            background: linear-gradient(90deg, #7C5CFC, #9F7AFF);
            border-radius: 14px;
            padding: 5px 14px;
            font-size: 12px;
            cursor: pointer;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 4px;
        }
    }

    .aip-body {
        background: rgba(18, 22, 32, 0.6);
        flex: 1;
        min-height: 0;
        padding: 10px 16px 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .aip-cards {
            display: grid;
            gap: 10px;

            &.row-4 {
                grid-template-columns: repeat(4, 1fr);
            }

            &.row-3 {
                grid-template-columns: repeat(3, 1fr);
                margin-top: 10px;
            }

            .aip-card {
                background: rgba(255, 255, 255, 0.03);
                border: 1px solid rgba(255, 255, 255, 0.06);
                border-radius: 10px;
                padding: 10px;
                transition: background 0.3s ease, border-color 0.3s ease;

                &:hover {
                    background: rgba(255, 255, 255, 0.1);
                    border-color: rgba(255, 255, 255, 0.15);
                }

                .card-icon {
                    width: 26px;
                    height: 26px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 8px;
                    overflow: hidden;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        display: block;
                    }
                }

                .card-name {
                    font-size: 12.5px;
                    font-weight: 600;
                    margin-bottom: 4px;
                    white-space: nowrap;
                }

                .card-desc {
                    font-size: 8px;
                    color: rgba(255, 255, 255, 0.5);
                    line-height: 1.4;
                }
            }
        }

        .aip-stats {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
            margin-top: 10px;

            .aip-stat {
                background: rgba(255, 255, 255, 0.03);
                border: 1px solid rgba(255, 255, 255, 0.06);
                border-radius: 10px;
                padding: 10px;

                .stat-label {
                    font-size: 11px;
                    color: rgba(255, 255, 255, 0.6);
                    margin-bottom: 5px;
                }

                .stat-value {
                    font-size: 22px;
                    font-weight: 700;
                    line-height: 1.2;

                    .unit {
                        font-size: 11px;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.5);
                        margin-left: 4px;
                    }
                }

                .stat-trend {
                    font-size: 10.5px;
                    margin-top: 4px;
                    color: rgba(255, 255, 255, 0.4);

                    &.up {
                        color: #3DBE8B;
                    }
                }
            }
        }
    }
}

/* ================== AI素材创作面板（绝对定位突出） ================== */
.ai-material-panel {
    position: absolute;
    right: -120px;
    /* 向右突出，与设备面板一致 */
    top: 50%;
    transform: translateY(-50%);
    width: 625px;
    height: 395.83px;
    zoom: 1.2;
    /* 实际渲染 750×475，与其他面板一致 */
    z-index: 2;

    display: flex;
    flex-direction: column;

    border-radius: 16px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    color: #fff;
    font-family: inherit;

    /* 面板头部：黑 80% */
    .amp-header {
        background: rgba(0, 0, 0, 0.8);
        padding: 14px 18px;
        flex-shrink: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .amp-title {
            display: flex;
            align-items: center;
            gap: 10px;

            .amp-logo-icon {
                width: 32px;
                height: 32px;
                flex-shrink: 0;
                background: linear-gradient(135deg, #8B5CF6, #6D28D9);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;

                /* 图标连背景整体使用设计切图 */
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }
            }

            .amp-title-text {
                .amp-name {
                    font-size: 15px;
                    font-weight: 600;
                    line-height: 1.3;
                }

                .amp-subtitle {
                    font-size: 11px;
                    color: rgba(255, 255, 255, 0.5);
                    margin-top: 2px;
                }
            }
        }

        .amp-auto-btn {
            background: linear-gradient(90deg, #7C5CFC, #9F7AFF);
            border-radius: 14px;
            padding: 5px 14px;
            font-size: 12px;
            cursor: pointer;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 4px;
        }
    }

    /* 面板内容：深蓝 60% */
    .amp-body {
        background: rgba(18, 22, 32, 0.6);
        flex: 1;
        min-height: 0;
        padding: 12px 16px 14px;
        display: flex;
        gap: 12px;

        /* 左列：风格模型 + 输入卡片 + 生成按钮 */
        .amp-left {
            width: 42%;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;

            /* 风格模型卡片（可交互） */
            .amp-style-card {
                background: rgba(255, 255, 255, 0.03);
                border: 1px solid rgba(255, 255, 255, 0.06);
                border-radius: 12px;
                padding: 12px;
                margin-bottom: 10px;

                .amp-style-head {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 10px;

                    .amp-style-title {
                        font-size: 13px;
                        color: rgba(255, 255, 255, 0.6);
                    }

                    .amp-more {
                        font-size: 12px;
                        color: #A78BFA;
                        cursor: pointer;
                    }
                }

                .amp-style-grid {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 8px;

                    /* 风格按钮：触摸/点击都有选中的紫色高亮效果 */
                    .style-btn {
                        height: 34px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #1B1E26;
                        border: 1px solid rgba(255, 255, 255, 0.06);
                        border-radius: 8px;
                        font-size: 13px;
                        color: rgba(255, 255, 255, 0.75);
                        cursor: pointer;
                        transition: all 0.25s ease;
                        user-select: none;

                        &:hover,
                        &.active {
                            background: rgba(139, 92, 246, 0.12);
                            border-color: #8B5CF6;
                            color: #A78BFA;
                        }
                    }
                }
            }

            /* 输入卡片（图片占位，可自行替换为 img） */
            .amp-input-card {
                flex: 1;
                min-height: 0;
                background: rgba(255, 255, 255, 0.03);
                border: 1px solid rgba(255, 255, 255, 0.06);
                border-radius: 12px;
                padding: 16px;
                margin-bottom: 10px;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .amp-input-placeholder {
                    font-size: 13px;
                    color: rgba(255, 255, 255, 0.5);
                    line-height: 1.7;
                    margin: 0;
                }

                .amp-input-icon {
                    align-self: flex-end;
                    color: rgba(255, 255, 255, 0.6);
                }
            }

            /* 生成按钮 */
            .amp-generate-btn {
                width: 100%;
                height: 44px;
                flex-shrink: 0;
                background: linear-gradient(90deg, #8B5CF6, #7C3AED);
                border: none;
                border-radius: 10px;
                color: #fff;
                font-size: 15px;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                    box-shadow: 0 0 20px rgba(139, 92, 246, 0.45);
                }
            }
        }

        /* 右侧画布（图片占位，可自行替换为 img） */
        .amp-canvas-card {
            flex: 1;
            min-width: 0;
            background: rgba(255, 255, 255, 0.03);
            border: 1px solid rgba(255, 255, 255, 0.06);
            border-radius: 12px;
            padding: 12px;
            display: flex;
            flex-direction: column;

            .amp-canvas-toolbar {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                flex-shrink: 0;

                .amp-save-btn {
                    background: rgba(255, 255, 255, 0.05);
                    border-radius: 8px;
                    padding: 7px 14px;
                    font-size: 12px;
                    color: rgba(255, 255, 255, 0.7);
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    cursor: pointer;
                }

                .amp-scale-switch {
                    display: flex;
                    gap: 4px;
                    background: rgba(255, 255, 255, 0.05);
                    border-radius: 8px;
                    padding: 3px;

                    .scale {
                        padding: 4px 12px;
                        border-radius: 6px;
                        font-size: 12px;
                        color: rgba(255, 255, 255, 0.5);
                        cursor: pointer;

                        &.active {
                            background: rgba(255, 255, 255, 0.1);
                            color: #fff;
                        }
                    }
                }
            }

            /* 点阵画布区域 */
            .amp-canvas-area {
                flex: 1;
                min-height: 0;
                border-radius: 10px;
                border: 1px solid rgba(255, 255, 255, 0.06);
                background-image: radial-gradient(rgba(255, 255, 255, 0.12) 1px, transparent 1px);
                background-size: 14px 14px;
            }
        }
    }
}

/* ================== AI客服图片（撑满右侧模块盒子） ================== */
.ai-service-image {
    position: absolute;
    right: -120px;
    /* 与其他面板同定位 */
    top: 50%;
    transform: translateY(-50%);
    /* 与其他面板同尺寸：625×395.83 + zoom 1.2 → 750×475 */
    width: 625px;
    height: 395.83px;
    zoom: 1.2;
    z-index: 2;

    border-radius: 16px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    background: rgba(18, 22, 32, 0.6);

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

/* 移动端专用裁切图：桌面隐藏，H5 媒体块内切换显示 */
.ai-service-image .service-img-mobile {
    display: none;
}

/* 其他几个盒子的占位 */
.carousel-image {
    flex: 1.2;
    position: relative;
}

.carousel-image img {
    width: 100%;
    height: auto;
    display: block;
}

.ai-card-nav {
    position: absolute;
    bottom: -18px;
    display: flex;
    justify-content: center;
    gap: 30px;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
    z-index: 10;
}

.arrow-btn {
    cursor: pointer;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.5);
    user-select: none;
    transition: color 0.3s;
}

.arrow-btn:hover {
    color: #FFD200;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

/* ================== AiGenNext 孵化项目模块 ================== */
.aigennext-section {
    position: relative;
    padding: 160px 0 180px;
    overflow: hidden;
    background: #0A0C1E;
}

.aigennext-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background-image: url('~@/assets/images/bg/容器 2740.png');
    background-size: cover;
    background-position: center;
}

.aigennext-content {
    position: relative;
    z-index: 2;
    text-align: center;
    padding: 40px 20px;
}

.aigennext-logo {
    font-size: 28px;
    font-weight: 700;
    color: #FFFFFF;
    letter-spacing: 2px;
    margin-bottom: 28px;
}

.aigennext-title {
    font-size: 56px;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 28px;

    .w3 {
        color: #FFD200;
    }

    .evo {
        background: linear-gradient(135deg, #A78BFA 0%, #8B5CF6 50%, #6366F1 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}

.aigennext-desc {
    font-size: 20px;
    color: rgba(255, 255, 255, 0.78);
    line-height: 1.8;
    max-width: 720px;
    margin: 0 auto;
}

/* 开始探索按钮（样式与 blog-single-column 的立即加入按钮一致） */
.aigennext-btn-wrap {
    margin-top: 50px;
    display: inline-flex;
    padding: 12px;
    background: rgba(255, 210, 0, 0.3);
    border: 1px solid #ffd200;
    border-radius: 60px;
    transition: all 0.35s ease;
    font-size: 20px;

    &:hover,
    &:active {
        background: #ffd200;
    }
}

.aigennext-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 15px 10px;
    background: #ffd200;
    border: none;
    border-radius: 50px;
    width: 200px;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    transition: all 0.35s ease;
    box-shadow: 0 0 30px rgba(255, 210, 0, 0.5);
    position: relative;

    &:hover {
        transform: translateY(-3px) scale(1.02);
        box-shadow: 0 0 50px rgba(255, 210, 0, 0.7);
    }

    &:active {
        transform: scale(0.97);
    }

    &::after {
        content: "↗";
        font-size: 20px;
        font-weight: 700;
        margin-left: 10px;
        font-family: sans-serif;
        position: relative;
        top: -1px;
    }
}

/* 响应式 */
@media (max-width: 768px) {
    .aigennext-section {
        padding: 100px 0 110px;
    }

    .aigennext-logo {
        font-size: 22px;
        margin-bottom: 20px;
    }

    .aigennext-title {
        font-size: 32px;
    }

    .aigennext-desc {
        font-size: 14px;
    }

    .ai-title {
        font-size: 32px;
    }

    .ai-desc {
        font-size: 14px;
    }

    .ai-buttons {
        gap: 16px;
    }

    .btn-ai {
        height: 46px;
        padding: 0 28px;
        font-size: 14px;
    }

    .carousel-header {
        margin-bottom: 60px;
        padding-top: 40px;
    }

    .carousel-header-title {
        font-size: 30px;
    }

    .carousel-header-desc {
        font-size: 14px;
        padding: 0 15px;
    }

    .carousel-inner {
        flex-direction: column;
        text-align: center;
        padding-right: 0;
    }

    .carousel-text {
        padding-left: 0;
        max-width: 100%;
    }

    .ai-icon-badge {
        margin: 0 auto 20px;
    }

    .carousel-list li {
        justify-content: center;
        text-align: left;
    }

    .device-panel {
        position: relative;
        right: auto;
        top: auto;
        transform: none;
        width: 100%;
        height: auto;
        zoom: 1;
        aspect-ratio: auto;
        margin-top: 20px;
    }

    .ai-interaction-panel {
        position: relative;
        right: auto;
        top: auto;
        transform: none;
        width: 100%;
        height: auto;
        zoom: 1;
        margin-top: 20px;
    }

    .ai-material-panel {
        position: relative;
        right: auto;
        top: auto;
        transform: none;
        width: 100%;
        height: auto;
        zoom: 1;
        aspect-ratio: auto;
        margin-top: 20px;
    }

    .ai-service-image {
        position: relative;
        right: auto;
        top: auto;
        transform: none;
        width: 100%;
        height: auto;
        zoom: 1;
        aspect-ratio: auto;
        margin-top: 20px;

        img {
            height: auto;
        }
    }

    /* 素材面板：移动端上下堆叠。
       桌面样式嵌套较深（.ai-material-panel .amp-body .amp-left），
       短链规则会被压制，这里用同等链长覆盖 */
    .ai-material-panel .amp-body {
        flex-direction: column;
    }

    .ai-material-panel .amp-body .amp-left {
        width: 100%;
    }
}

/* ========== H5 面板内部适配补充（不影响桌面端） ========== */
@media (max-width: 768px) {
    .yantai-ai-section {
        min-height: auto;
    }

    .ai-content {
        padding: 90px 20px 70px;
    }

    .yantai-ai-carousel-section {
        overflow: hidden;
    }

    .ai-carousel {
        padding: 20px 14px;
        border-radius: 16px;
    }

    .carousel-inner {
        min-height: auto;
        gap: 0;
    }

    .carousel-title {
        font-size: 26px;
    }

    .carousel-desc {
        font-size: 14px;
    }

    .carousel-list li {
        font-size: 14px;
    }

    /* 设备面板（桌面为深嵌套选择器，短链规则会被压制，这里用同等链长覆盖） */
    .device-panel .dp-stats {
        grid-template-columns: repeat(2, 1fr);
    }

    .device-panel .dp-filter {
        flex-wrap: wrap;
    }

    .device-panel .dp-filter .dp-tags {
        flex-wrap: wrap;
    }

    .device-panel .dp-list {
        grid-template-columns: 1fr;
    }

    /* AI互动面板 */
    .ai-interaction-panel .aip-body .aip-cards.row-4 {
        grid-template-columns: repeat(2, 1fr);
    }

    .ai-interaction-panel .aip-body .aip-cards.row-3 {
        grid-template-columns: repeat(2, 1fr);
    }

    .ai-interaction-panel .aip-body .aip-cards .aip-card .card-name {
        white-space: normal;
        font-size: 12px;
    }

    .ai-interaction-panel .aip-body .aip-cards .aip-card .card-desc {
        font-size: 10px;
    }

    .ai-interaction-panel .aip-body .aip-stats {
        grid-template-columns: repeat(2, 1fr);
    }

    /* 素材面板：风格按钮改为流式胶囊，避免窄格里文字竖排 */
    .ai-material-panel .amp-body .amp-left .amp-style-card .amp-style-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .ai-material-panel .amp-body .amp-left .amp-style-card .amp-style-grid .style-btn {
        width: auto;
        height: auto;
        padding: 8px 14px;
        white-space: nowrap;
    }

    .ai-material-panel .amp-body .amp-canvas-card .amp-canvas-area {
        min-height: 200px;
    }

    /* 统一四个轮播面板的高度：
       桌面端四个面板均为 600×400（aspect-ratio 3/2），
       H5 转为上下流式后高度由内容撑开导致四个轮播大小不一，
       这里固定统一高度，内容超出时在面板内部滚动 */
    .device-panel,
    .ai-interaction-panel,
    .ai-material-panel,
    .ai-service-image {
        height: 500px;
    }

    /* 面板内容超出时内部滚动，避免被 overflow:hidden 裁切 */
    .device-panel .dp-list,
    .ai-interaction-panel .aip-body,
    .ai-material-panel .amp-body {
        min-height: 0;
        overflow-y: auto;
    }

    /* space-between 在内容溢出时会导致顶部被裁，改为顶对齐（间距沿用子元素 margin） */
    .ai-interaction-panel .aip-body {
        justify-content: flex-start;
    }

    /* 第4个面板为纯图片：填满统一高度 */
    .ai-service-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    /* H5 切换为竖版裁切图 */
    .ai-service-image .service-img-desktop {
        display: none;
    }

    .ai-service-image .service-img-mobile {
        display: block;
    }

    /* 首屏按钮：固定 200px 宽度在英文/越南语下会导致文字换行竖排，
       改为宽度随文字自适应 + 禁止换行，放不下时整体换行堆叠 */
    .ai-buttons {
        flex-wrap: wrap;
        gap: 12px;
    }

    .btn-ai {
        width: auto;
        white-space: nowrap;
        height: 46px;
        padding: 0 22px;
        font-size: 14px;
    }
}
</style>